import React, { Component } from "react";
import { Link } from 'react-router-dom'

class AdminHeader extends Component {
    render() {
        return (
            <div className="col s12 l3 m4 valign-wrapper admin-header" id="navigator_wrap">
            <div id="logo-wrapper" className="admin-left">
                <div id="logo" className="center">
                <img src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/tr-element.png" width="200px" alt="" />
                </div>
                <div className="center">
                <button onClick={() => this.props.setActiveFilter("all")} className="btn active">All</button>
                <button onClick={() => this.props.setActiveFilter("1")} className="btn">Approved</button>
                <button onClick={() => this.props.setActiveFilter("0")} className="btn">Unapproved</button>
                <button onClick={() => this.props.setActiveFilter("2")} className="btn">Rejected</button>
                <br/>
                <Link to="/login">Logout</Link>
                </div>
            </div>
            </div>
        );
    }
};
export default AdminHeader;



// WEBPACK FOOTER //
// ./src/components/AdminHeader.js